(ns bec-core.cljs.views.countries
  (:require [re-frame.core :as rf]
            [bec-cljs-common.components.icon :refer [icon]]))

(defn information [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:section.hero.is-danger
    [:div.hero-body
     [:div.container
      [:p.title "Venue"]
      [:p.subtitle "All systems are working ok"]
      [:p "23 notifications recieved since last you logged in"]]]]
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venue {:subview :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defn settings [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venue {:subview :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defn actions [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venue {:subview :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:subview :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defn default [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"
             :text-align "center"}}
    [:h1.title.is-1
     {:style {:text-align "center"}}
     (str "Country: " (:country props))]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:style {:filter "drop-shadow(0px 0px 0.0625rem var(--blue))"}
          :on-click #(rf/dispatch [:select-view :venues {:subview :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           {:style {:filter "drop-shadow(0px 0px 0.125rem var(--blue))"}}
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:style {:filter "drop-shadow(0px 0px 0.0625rem var(--blue))"}
         :on-click #(rf/dispatch [:select-view :venues {:subview :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          {:style {:filter "drop-shadow(0px 0px 0.125rem var(--blue))"}}
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:style {:filter "drop-shadow(0px 0px 0.0625rem var(--blue))"}
         :on-click #(rf/dispatch [:select-view :venues {:subview :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          {:style {:filter "drop-shadow(0px 0px 0.125rem var(--blue))"}}
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]
    [:div.tile.is-ancestor
     {:style {:justify-content "center"}}
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venues])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-list-ul]]]
          [:h1.title "Go back to venue list"]]]]]]]]])

(defn list-view [& [props]]
  (let [countries @(rf/subscribe [:main-search-countries])]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      {:style {:margin "1.5rem 0"
               :text-align "center"}}
      [:nav.panel
       [:header.panel-heading
        [:p.title "Select venue"]]
       [:div.panel-block
        {:style {:text-align "start"
                 :border-bottom "solid 1px var(--scheme-invert)"}}
        [:div
         {:style {:width "50%"}}
         [:p.subtitle "Identifier"]]
        [:div
         {:style {:width "50%"}}
         [:p.subtitle "Address"]]]
       (into
         [:div.panel-body]
         (map
           (fn [country]
             [:a.panel-block
              {:style {:text-align "start"}
               :on-click #(rf/dispatch
                            [:dispatch-many
                             [[:dispatch [:assoc-in [:venue] (:id (:information country))]]
                              [:dispatch [:select-view :venues {:subview :options}]]]])}
              [:div
               {:style {:width "50%"}}
               [:p (:id (:information country))]]
              [:div
               {:style {:width "50%"}}
               [:p (:address (:information country))]]])
           countries))]]]))

(defn view [& [props]]
  (let [selected-country @(rf/subscribe [:get-in [:country]])]
    (case (:subview props)
      :information [information {:country selected-country}]
      :settings [settings {:country selected-country}]
      :actions [actions {:country selected-country}]
      :options [default {:country selected-country}]
      [list-view {:country selected-country}])))